import { createContext } from "react";

export const SearchBoxContext = createContext({});